import { DSTab, styled } from '@vr/ds-react'

export const Label = styled('label', {
  display: 'block',
  margin: '10px 0 5px',
  width: 'fit-content',
  color: '$neutralVeryDark',
  lineHeight: '$subLarge',
  fontSize: '$subMedium',
  fontWeight: '$bold',
  paddingLeft: '$sm12',
  paddingRight: '$sm12',
  marginBottom: '$sm16'
})

export const InfoText = styled('p', {
  fontSize: '$extraSmall',
  color: '$neutralVeryDark',
  paddingLeft: '$sm12',
  paddingRight: '$sm12',
  paddingTop: '$sm16'
})

export const Item = styled(DSTab.Item, {
  width: '22.3%',
  textAlign: 'center'
})
